<form>

  <div mat-dialog-content class="qualificates-theme">

    <div fxLayout="column" class="flexwrap">

      <div fxFlex fxLayout="column">
        <div fxFlex="100">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.equipment.label' | translate }}</mat-label>
            <input matInput [ngModel]="equipmentName" #trigger="matAutocompleteTrigger" [matAutocomplete]="auto"
              (keyup)="lookupEquipment($event)" [ngModelOptions]="{standalone: true}">
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn"
              (optionSelected)="onSensorChange($event, trigger)">
              @for (item of equipmentAutoComplete; track item; let index = $index) {
                <mat-option [value]="item">
                  {{ item.name}} ({{item.serialNum}})
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div fxFlex="100">
          <span>{{'calibrateEquipmentEdit.patterns.dialog.selected.label' | translate}}</span>
          @for (item of this.data.item.equipment; track item; let indexPttern = $index) {
            <div>
              <div fxFlex="90" style="align-content: center;">
                <span>{{item.name}}</span>
              </div>
              <div fxFlex="5" fxFlex.lt-md="100%" style="align-content: center;">
                @if (data.item.idEquipment != null) {
                  <button mat-icon-button (click)="deleteRowPatternSelected(indexPttern)">
                    <mat-icon>cancel</mat-icon>
                  </button>
                }
              </div>
              <div fxFlex="5">
                @if (data.item.idEquipment != null) {
                  <button mat-icon-button (click)="downloadPdf(data.item.idEquipment)">
                    <mat-icon>cloud_download</mat-icon>
                  </button>
                }
              </div>
            </div>
          }
        </div>
      </div>

      <div fxFlex>
        {{ 'calibrateEquipmentEdit.patterns.dialog.values.label' | translate }}
      </div>

      <div fxFlex>

        @for (value of data.item.values; track value; let indexValue = $index) {
          <div fxLayout="row" fxLayout.xs="column" class="flexwrap"
            >
            <div fxFlex="5" style="padding-top: 1em;">
              <mat-checkbox name="include{{indexValue}}" color="primary" [checked]="value.include"
                (change)="setValue(indexValue, $event, 'include')" [disabled]="equipmentName == null">
              </mat-checkbox>
            </div>
            <div fxFlex="10" fxFlex.lt-md="95%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.values.number.label' | translate }}</mat-label>
                <input matInput name="num{{indexValue}}" [ngModel]="indexValue + 1" disabled>
              </mat-form-field>
            </div>
            <div fxFlex="15" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.values.value.label' | translate }}</mat-label>
                <input matInput type="number" name="value{{indexValue}}" [ngModel]="value.value" disabled>
                <mat-error>
                  {{ 'calibrateEquipmentEdit.patterns.dialog.values.value.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="10" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.values.unit.label' | translate }}</mat-label>
                <input matInput name="unit{{indexValue}}" [ngModel]="data.variable?.unitName" disabled>
              </mat-form-field>
            </div>
            @if (vBalanceMass?.length > 0) {
              <div fxFlex="20" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.values.mass.label' | translate}}</mat-label>
                  <mat-select multiple name="idMass{{indexValue}}" [(ngModel)]="value.idMass"
                    (selectionChange)="onSumMass(indexValue, $event, value)">
                    @for (item of vBalanceMass; track item) {
                      <mat-option [value]="item.id"
                        checkboxPosition="before" [matTooltip]="(item.idMass ? item.idMass + ' - ' : '')">
                        {{ item.annotation ? item.pointUnit + ' (·)' : item.pointUnit }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.values.uncertainty.label' | translate }}</mat-label>
                <input matInput type="number" name="uncertainty{{indexValue}}" [ngModel]="value.uncertainty | smartNumber"
                  [disabled]="equipmentName == null" required>
                <mat-error>
                  {{ 'calibrateEquipmentEdit.patterns.dialog.values.uncertainty.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            @if (value.idMass && value.valid) {
              <div fxFlex="5" fxFlex.lt-md="100%" style="align-content: center;">
                <mat-icon style="color:#008000b5">check_circle</mat-icon>
              </div>
            }
            @if (value.idMass && !value.valid) {
              <div fxFlex="5" fxFlex.lt-md="100%" style="align-content: center;">
                <mat-icon style="color:#ff00009e">cancel</mat-icon>
              </div>
            }
          </div>
        }

      </div>

    </div>

  </div>
  <div mat-dialog-actions class="calibrates-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial>{{ 'button.save' | translate
    }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>